import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StateService, Command } from 'flux-core';
import { ShapeModel } from '../../../base/shape/model/shape.mdl';
import { DiagramChangeService } from '../../../base/diagram/diagram-change.svc';
import { AbstractDiagramChangeCommand } from './abstract-diagram-change-command.cmd';
import { Restriction } from '../restriction/restriction.svc';

@Injectable()
@Command()
export class MoveToFrame extends AbstractDiagramChangeCommand {

    public data: {
        shapeIds?: string[],
        frameId?: string,
        moveFrame?: boolean,
        useFrameBounds?: boolean,
        force?: boolean,
    }

    constructor(
        protected ds: DiagramChangeService,
        protected state: StateService<any, any>,
        protected restriction: Restriction,
    ) {
        super( ds );
    }

    public prepareData(): void | Observable<any> {
        let frameId = this.data?.frameId;
        this.resultData = {};
        const shapeData = {};
        let containerData = {};
        const containerMoveScaleChanges: any = {}
        let shapeIds = this.data.shapeIds;

        if ( !shapeIds && this.data.useFrameBounds ) {
            const shapeBounds = ( this.changeModel.shapes[ frameId ] as ShapeModel ).bounds;
            shapeIds = this.changeModel.getEnclosedShapes( shapeBounds ).filter( shape => !shape.isConnector()).map( shape => shape.id );
        }

        if ( !shapeIds || shapeIds.length < 1 || !frameId ) {
            return;
        }
    
        const childrenShapes = [];
        for ( const shapeId of shapeIds ) {
            const shape = this.changeModel.shapes[ shapeId ] as ShapeModel;
            if (( this.data.force || !shape?.isConnector()) && ( !shape.containerId || !shapeIds.includes( shape.containerId ))) {
                childrenShapes.push( shapeId );
            }
        }

        const frame = this.changeModel.shapes[ frameId ] as ShapeModel;
        const padding = 30;

        if ( this.data.moveFrame ) {
            const bounds = this.changeModel.getBounds(childrenShapes, true);
            const totalPadding = padding * 2;

            // Calculate required width and height for bounds + padding
            const requiredWidth = bounds.width + totalPadding;
            const requiredHeight = bounds.height + totalPadding;

            // Set frame's scaleX and scaleY only if needed
            frame.scaleX = Math.max(( requiredWidth / frame.defaultBounds.width ), frame.scaleX || 1 );
            frame.scaleY = Math.max(( requiredHeight / frame.defaultBounds.height ), frame.scaleY || 1 );

            // Now, position frame so it centers over the bounds
            const frameWidth = frame.defaultBounds.width * frame.scaleX;
            const frameHeight = frame.defaultBounds.height * frame.scaleY;

            const r = this.restriction.point({
                x: bounds.left + ( bounds.width / 2) - ( frameWidth / 2 ),
                y: bounds.top + ( bounds.height / 2) - ( frameHeight / 2 ),
            }, [ 'GridService' ]);

            frame.x = r.x;
            frame.y = r.y;
        }

        childrenShapes.map( shapeId => {
            shapeData[shapeId] = {
                expand: false,
                action: 'enter',
                containerId: frameId,
                force: false,
            };
        });
        containerData = { [frameId]: { isContainer: true }};
        this.resultData = { frameId: frameId, childrenData: shapeData, containerData: containerData, containerMoveScaleChanges }
    }
}

Object.defineProperty( MoveToFrame, 'name', {
    value: 'MoveToFrame',
});
